import { Component, OnInit, Inject } from '@angular/core';
import { Funcionario } from 'src/app/models/funcionario';
import { FiltroPedido } from 'src/app/models/filtro-pedido';
import { StatusDoPedido, PerfilDoUsuario, OrigemFiltroPedido } from 'src/app/models/enum';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { GlobalService } from 'src/app/services/global.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { Etapa } from 'src/app/models/etapa';
import { EtapaService } from 'src/app/services/etapa.service';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { CRMHierarquiaUsuario } from 'src/app/models/crmhierarquia-usuario';
import { Cliente } from 'src/app/models/cliente';
import { ClienteService } from 'src/app/services/cliente.service';
import { OrcStatus } from 'src/app/models/orc-status';
import { OrcStatusService } from 'src/app/services/orc-status.service';
import { UsuarioIntegrador } from 'src/app/models/usuario-integrador';
import { UsuarioIntegradorService } from 'src/app/services/usuario-integrador.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { PremissasSistema } from 'src/app/models/premissas-sistema';

@Component({
  selector: 'app-filtro-pedido',
  templateUrl: './filtro-pedido.component.html',
  styleUrls: ['./filtro-pedido.component.scss']
})
export class FiltroPedidoComponent implements OnInit {

  filtroPedido: FiltroPedido;
  vendedores: CRMHierarquiaUsuario[] = [];
  statusPedido = [
    { id: 999, nome: 'Todos' },
    { id: StatusDoPedido.Ativo, nome: 'Ativo' },
    { id: StatusDoPedido.Cancelado, nome: 'Cancelado' },
    { id: StatusDoPedido.Expirado, nome: 'Expirado' }
  ];
  statusPedidoSelecionado: number;
  etapas: Etapa[] = [];
  clientes: Cliente[] = [];
  integrador = false;
  carregando = true;
  PerfilDoUsuario = PerfilDoUsuario;
  perfil: PerfilDoUsuario;
  texto = '';
  tipo: number;
  usuario: UsuarioLogado;
  administrador = false;
  orcsStatus: OrcStatus[] = [];
  usuariosDoIntegrador: UsuarioIntegrador[] = [];
  public config: PerfectScrollbarConfigInterface = {};
  repasse = false;

  usarCentroDeDistribuicao = false;
  fornecedores = [];
  premissasSistema: PremissasSistema;

  itensSimNao = [{ valor: true, descricao: 'Sim' }, { valor: false, descricao: 'Não' }];

  origem: OrigemFiltroPedido;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private pedidoService: PedidoService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private router: Router,
    private etapaService: EtapaService,
    private clienteService: ClienteService,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private funcionarioService: FuncionarioService,
    private utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<FiltroPedidoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orcStatusService: OrcStatusService,
    private usuarioDoIntegradorService: UsuarioIntegradorService,
    private fornecedorService: FornecedorService,
    private premissasService: PremissasService
  ) {
    this.filtroPedido = data.filtro;
    this.tipo = data.tipo;
    this.repasse = data.repasse;
    this.origem = data.origem;
  }

  async ngOnInit() {

    this.buscarPremissasSistema();

    this.texto = this.tipo === 0 ? 'Orçamento' : 'Pedido';

    if (this.filtroPedido.status === undefined) {
      this.statusPedidoSelecionado = 999;
    } else {
      this.statusPedidoSelecionado = this.filtroPedido.status === null ? 999 : this.filtroPedido.status;
    }

    this.administrador = await this.globalService.administrador();
    this.perfil = await this.globalService.perfil();
    this.usuario = await this.globalService.consultaUsuario();
    this.integrador = await this.globalService.integrador();

    if (this.integrador && this.usuario.verTodosPedidos) {
      this.buscarUsuariosDoIntegrador();
    }

    this.buscarEtapas();

    if (this.perfil === PerfilDoUsuario.Suporte || this.perfil === PerfilDoUsuario.Administrador || this.perfil === PerfilDoUsuario.Vendedor) {
      this.buscarVendedores();
      this.buscarClientes();
    }

    if (this.tipo === 0) {
      this.buscarStatusOrcamento();
    }

    this.buscarPremissaCentroDeDistribuicao();
    this.buscarFornecedores();
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      centro => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        if (centro.valor) {
          this.usarCentroDeDistribuicao = true;
          this.buscarFornecedores();
        }
      },
      err => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      premissas => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      err => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');
    this.fornecedorService.consultarFornecedores().subscribe(
      forn => {
        this.carregandoService.esconde('buscarFornecedores');
        this.fornecedores = forn;
      },
      err => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarVendedores() {

    if (!this.filtroPedido.pesquisaPorTimes && (this.administrador || (!this.usuario.verSomenteHierarquia && (this.origem === OrigemFiltroPedido.Orcamento || this.origem === OrigemFiltroPedido.Pedido)))) {
      this.carregandoService.mostra('buscarVendedores');

      this.funcionarioService.consultarFuncionariosPedido().subscribe(resp => {
        this.vendedores = resp.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));
        if (this.vendedores.length > 1) {
          this.vendedores.unshift({ idFuncion: 0, nome: 'Todos' });
        }
        this.carregandoService.esconde('buscarVendedores');
      }, (erro) => {
        this.carregandoService.esconde('buscarVendedores');
        this.notificacaoService.erro(erro);
      });
    }
    else {
      this.carregandoService.mostra('buscaUsuarios');

      this.hierarquiaService.consultarHierarquiaDoUsuarioLista(undefined, this.filtroPedido.pesquisaPorTimes, undefined, false).subscribe(resp => {
        this.vendedores = resp;

        this.vendedores.splice(this.vendedores.
          indexOf(this.vendedores.find(p => p.idFuncion === Number(this.usuario.id))), 1);

        if (this.vendedores.length > 0) {
          const todos = new CRMHierarquiaUsuario();
          todos.idFuncion = 0;
          todos.nome = 'Todos';
          this.vendedores.unshift(todos);
        }

        const somenteEu = new CRMHierarquiaUsuario();
        somenteEu.idFuncion = -1;
        somenteEu.nome = 'Somente eu';
        this.vendedores.unshift(somenteEu);

        this.carregandoService.esconde('buscaUsuarios');
      }, (erro) => {
        this.carregandoService.esconde('buscaUsuarios');
        this.notificacaoService.erro(erro);
      });
    }
  }


  buscarClientes() {

    this.carregandoService.mostra('buscarClientes');
    this.filtroPedido.integrador = undefined;
    this.clienteService.consultarClientesDoVendedor(this.filtroPedido.funcionario === 0 ? undefined : this.filtroPedido.funcionario === -1 ? this.usuario.id : this.filtroPedido.funcionario).subscribe(resp => {
      this.clientes = resp;
      const todos = new Cliente();
      todos.id = undefined;
      todos.nome = 'Todos';
      this.clientes.unshift(todos);

      this.carregandoService.esconde('buscarClientes');
    }, (erro) => {
      this.carregandoService.esconde('buscarClientes');
      this.notificacaoService.erro(erro);
    });
  }

  buscarEtapas() {

    this.carregandoService.mostra('buscarEtapas');

    this.etapaService.consultarParaFiltro().subscribe(resp => {
      this.etapas = resp;
      this.carregandoService.esconde('buscarEtapas');
    }, (erro) => {
      this.carregandoService.esconde('buscarEtapas');
      this.notificacaoService.erro(erro);
    });
  }

  filtrar() {
    this.filtroPedido.status = this.statusPedidoSelecionado === 999 ? null : this.statusPedidoSelecionado;

    this.dialogRef.close(this.filtroPedido);
  }

  fechar() {
    this.dialogRef.close();
  }

  restaurarFiltros() {
    this.filtroPedido = {
      dtFim: undefined, dtInicio: undefined, funcionario: this.administrador ? 0 : (!this.integrador ? -1 : undefined), idCupom: '', nomeCliente: '', status: undefined, etapas: [],
      integrador: undefined, orcStatus: undefined, idUsuarioIntegrador: undefined, referencia: undefined, idFornecedor: undefined, codErp: '', pesquisaPorTimes: false
    };
  }

  buscarStatusOrcamento() {
    this.carregandoService.mostra('buscarStatusOrcamento');
    this.carregando = true;
    this.orcStatusService.consultar(this.repasse ? 1 : 0).subscribe((data: any) => {
      this.orcsStatus = data;
      this.carregando = false;
      this.carregandoService.esconde('buscarStatusOrcamento');
    }, (erro) => {
      this.carregandoService.esconde('buscarStatusOrcamento');
      this.notificacaoService.erro(erro);
    });
  }

  buscarUsuariosDoIntegrador() {
    this.carregandoService.mostra('buscarUsuariosDoIntegrador');
    this.usuarioDoIntegradorService.consultarPorIdIntegrador(this.usuario.id).subscribe(
      (f) => {
        this.usuariosDoIntegrador = f;
        const usuTodos = new UsuarioIntegrador();
        usuTodos.nome = 'Todos';
        usuTodos.id = undefined;
        this.usuariosDoIntegrador.unshift(usuTodos);
        this.carregandoService.esconde('buscarUsuariosDoIntegrador');
      },
      (erro) => {
        this.carregandoService.esconde('buscarUsuariosDoIntegrador');
        this.notificacaoService.erro(erro);
      }
    );
  };
}
